import { BaseResourceModel } from '../../models/base-resource.model';
import { EmendaParlamentar } from './emenda-parlamentar.model';

export class EmendaParlamentarCronograma extends BaseResourceModel {
  constructor(
    public id?: number,
    public emenda?: EmendaParlamentar,
    public mes?: number,
    public ano?: number,
    public valor?: number,
    public evento?: string,
  ) {
    super();
  }

  static converteJson(json: any): EmendaParlamentarCronograma {
    return Object.assign(new EmendaParlamentarCronograma(), json);
  }
}
